var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"Text"}},[_c('div',{attrs:{"align":"center"}},[_c('br'),_c('br'),_c('div',{staticClass:"bullets"},[_vm._v(" Please send any suggestions or problems related to this portal to "),_c('a',{staticClass:"link-container",attrs:{"target":"_blank","href":"mailto:sunbeam.abc.web@gmail.com"}},[_vm._v("SunBEAm-ABC")]),_vm._v(". ")])])])
}]

export { render, staticRenderFns }